// Components==============
import { faGlobe } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button';
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useRef } from 'react';
import { interactiveScale } from 'utilities/framerAnimations';
import './Card.module.scss';
import { SchoolsContext } from 'screens/Schools/Schools';
// =========================

export default function Card({ school }) {
    const { selected, setSelected } = useContext(SchoolsContext);

    const { name, contact, index } = school;

    const active = selected === index;

    const ref = useRef();

    useEffect(() => {
        if (active) {
            window?.scrollTo({
                top: ref?.current?.offsetTop,
            });
        }
    }, [selected]);

    console.log(school?.image);

    return (
        <motion.div
            {...interactiveScale}
            onClick={() => {
                if (selected === index) {
                    setSelected(null);
                } else {
                    setSelected(index);
                }
            }}
            styleName={`card ${active ? 'active' : ''} ${
                school?.image !== null ? 'image' : ''
            }`}
            ref={ref}
        >
            <div styleName="background" />
            <div
                styleName="image"
                style={{
                    background: `url(${school?.image})`,
                    // add no repeat to the background image
                    backgroundRepeat: 'no-repeat',
                    // center the image
                    backgroundPosition: 'center',
                    // set the size of the image
                    backgroundSize: 'cover',
                }}
            />
            <div styleName="content">
                <div styleName="top">
                    <h3>{name}</h3>
                </div>
                <div styleName="contact">
                    {contact?.street && (
                        <div>
                            <p>{contact.city}</p>
                            <p>{school?.type}</p>
                        </div>
                    )}
                </div>
                <a target="_blank" rel="noreferrer" href={`${contact.website}`}>
                    <Button color={active ? 'blue' : 'white'}>
                        Bekijk website <FontAwesomeIcon icon={faGlobe} />
                    </Button>
                </a>
            </div>
        </motion.div>
    );
}
